module.exports = __webpack_public_path__ + "img/certificates.b05e2a93.svg";